export const convertToRadians = (degree) => {
    return degree * (Math.PI / 180);
};
const NORTH_EAST = 0;
const SOUTH_WEST = 1;
const LAT = 0;
const LNG = 1;
const yandexMapUtils = {
    calculateRadius: (map) => {
        const bounds = map.bounds;
        const northEast = bounds[NORTH_EAST];
        const southWest = bounds[SOUTH_WEST];
        const neLng = convertToRadians(northEast[LNG]);
        const neLat = convertToRadians(northEast[LAT]);
        const swLng = convertToRadians(southWest[LNG]);
        const swLat = convertToRadians(southWest[LAT]);
        const dlon = swLng - neLng;
        const dlat = swLat - neLat;
        const haversineFormula = Math.sin(dlat / 2) ** 2 + Math.cos(neLat) * Math.cos(swLat) * Math.sin(dlon / 2) ** 2;
        const centralAngle = 2 * Math.atan2(Math.sqrt(haversineFormula), Math.sqrt(1 - haversineFormula));
        const EARTH_RADIUS_IN_KM = 6371;
        const distance = EARTH_RADIUS_IN_KM * centralAngle;
        const distanceInMeters = distance * 1000;
        return Number(distanceInMeters.toFixed(2)) / 4;
    },
    handleGetLatAndLng: (map) => {
        const center = map.center;
        return {
            lat: Number(center[1].toFixed(6)),
            lng: Number(center[0].toFixed(6)),
        };
    },
};
const naverMapUtils = {
    calculateRadius: (map) => {
        const bounds = map.getBounds();
        if (!bounds?.getNE() || !bounds?.getSW()) {
            return 0;
        }
        const northEast = bounds.getNE();
        const southWest = bounds.getSW();
        // calculation based on Haversine_formula - https://en.wikipedia.org/wiki/Haversine_formula
        // created based on https://stackoverflow.com/questions/14560999/using-the-haversine-formula-in-javascript
        const neLng = convertToRadians(northEast.lng());
        const neLat = convertToRadians(northEast.lat());
        const swLng = convertToRadians(southWest.lng());
        const swLat = convertToRadians(southWest.lat());
        const dlon = swLat - neLat;
        const dlat = neLng - swLng;
        const haversineFormula = Math.sin(dlat / 2) ** 2 + Math.cos(neLat) * Math.cos(swLat) * Math.sin(dlon / 2) ** 2;
        const centralAngle = 2 * Math.atan2(Math.sqrt(haversineFormula), Math.sqrt(1 - haversineFormula));
        const EARTH_RADIUS_IN_KM = 6371;
        const distance = EARTH_RADIUS_IN_KM * centralAngle; // distance in km
        const distanceInMeters = distance * 1000; // distance in meters
        return Number(distanceInMeters.toFixed(2)) / 2;
    },
    handleGetLatAndLng: (map) => {
        const center = map.getCenter();
        return {
            lat: Number(center.y.toFixed(6)),
            lng: Number(center.x.toFixed(6)),
        };
    },
};
const googleMapUtils = {
    calculateRadius: (map) => {
        const bounds = map.getBounds();
        if (!bounds) {
            return 0;
        }
        const northSouthRadius = google.maps.geometry.spherical.computeDistanceBetween(bounds.getCenter(), bounds.getNorthEast());
        const eastWestRadius = google.maps.geometry.spherical.computeDistanceBetween(bounds.getCenter(), bounds.getSouthWest());
        const radius = Math.max(northSouthRadius, eastWestRadius);
        return Number(radius.toFixed(2));
    },
    handleGetLatAndLng: (map) => {
        const center = map.getCenter();
        return {
            lat: center.lat(),
            lng: center.lng(),
        };
    },
};
export const getLatLngAndRadius = (map) => {
    if (typeof google !== "undefined" && map instanceof google.maps.Map) {
        const { calculateRadius, handleGetLatAndLng } = googleMapUtils;
        return { ...handleGetLatAndLng(map), radius: calculateRadius(map) };
    }
    if (typeof naver !== "undefined" && map instanceof naver.maps.Map) {
        const { calculateRadius, handleGetLatAndLng } = naverMapUtils;
        return { ...handleGetLatAndLng(map), radius: calculateRadius(map) };
    }
    if (typeof ymaps3 !== "undefined" && map instanceof ymaps3.YMap) {
        const { calculateRadius, handleGetLatAndLng } = yandexMapUtils;
        return { ...handleGetLatAndLng(map), radius: calculateRadius(map) };
    }
    return { lat: 0, lng: 0, radius: 0 };
};
//# sourceMappingURL=calculateRadius.js.map